import { matchRoutes } from "react-router-config";

import routes from "../web/routes";

export default function getIsGenericStaticPageRoute(pathname) {
  if (!pathname) {
    return false;
  }

  const branch = matchRoutes(routes, pathname);
  if (!branch?.length) {
    return false;
  }

  return !!branch[branch.length - 1]?.route?.isGenericStaticPage;
}
